export type ExplanationLayoutInput = {
  viewportTop: number;
  viewportBottom: number;
  viewportScrollTop: number;
  viewportScrollHeight: number;
  viewportClientHeight: number;
  topbarBottom: number;
  playerTop: number;
  windowHeight: number;
  sentenceTop: number;
  sentenceHeight: number;
  topGap?: number;
  panelGap?: number;
  minimumPanelHeight?: number;
};

export type ExplanationLayout = {
  targetScrollTop: number;
  finalSentenceTop: number;
  translateY: number;
  panelHeight: number;
};

export function computeExplanationLayout(input: ExplanationLayoutInput): ExplanationLayout {
  const topGap = input.topGap ?? 14;
  const panelGap = input.panelGap ?? 10;
  const minimumPanelHeight = input.minimumPanelHeight ?? 240;
  const visibleTop = Math.max(0, input.viewportTop, input.topbarBottom);
  const visibleBottom = Math.min(input.windowHeight, input.viewportBottom, input.playerTop);
  const desiredSentenceTop = visibleTop + topGap;
  const maximumScrollTop = Math.max(0, input.viewportScrollHeight - input.viewportClientHeight);
  const targetScrollTop = clamp(
    input.viewportScrollTop + input.sentenceTop - desiredSentenceTop,
    0,
    maximumScrollTop,
  );
  const finalSentenceTop = input.sentenceTop - (targetScrollTop - input.viewportScrollTop);
  const translateY = finalSentenceTop - input.sentenceTop;
  const panelHeight = Math.floor(Math.max(
    minimumPanelHeight,
    visibleBottom - finalSentenceTop - input.sentenceHeight - panelGap,
  ));

  return { targetScrollTop, finalSentenceTop, translateY, panelHeight };
}

function clamp(value: number, minimum: number, maximum: number) {
  return Math.min(maximum, Math.max(minimum, value));
}
